// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthModal_authModal__top__AjVIH {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.AuthModal_authModal__resendBtn__uow7O {
  text-decoration: underline;
  letter-spacing: -0.02em;
  color: #457CFA;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}
@media (min-width: 1200px) {
  .AuthModal_authModal__resendBtn__uow7O {
    margin-bottom: 0;
  }
}
.AuthModal_authModal__resendBtn__uow7O:hover {
  text-decoration: none;
}
.AuthModal_authModal__codeEnd__4MYI0 {
  font-size: 14px;
  color: var(--error);
  line-height: 12px;
  text-align: left;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  transition: 0.15s;
}
@media (min-width: 1200px) {
  .AuthModal_authModal__codeEnd__4MYI0 {
    justify-content: center;
    margin-top: 12px;
  }
}
.AuthModal_authModal__codeEnd__4MYI0 span {
  margin-right: 6px;
  margin-bottom: 4px;
  color: var(--error);
  font-size: var(--fz-sm);
  font-weight: 600;
  line-height: var(--lh-md);
}
@media (min-width: 1200px) {
  .AuthModal_authModal__codeEnd__4MYI0 span {
    font-weight: normal;
    line-height: var(--lh-sm);
    margin-bottom: 0;
  }
}
@media (min-width: 1200px) {
  .AuthModal_authModal__1Sav- .error-text {
    text-align: center;
    font-weight: normal;
    left: 0;
    right: 0;
    width: auto;
    margin-top: 4px;
  }
}
.AuthModal_authModal__1Sav- .modal-title {
  font-size: 24px;
}
.AuthModal_authModal__1Sav- .AuthModal_error-validation__2OuNs {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  line-height: 16px;
  color: #FF3C3C;
  margin: 12px auto 0;
}

@media (min-width: 1200px) {
  div.AuthModal_authHead__mmVPE {
    display: block;
    text-align: center;
  }
}
@media (min-width: 1200px) {
  div.AuthModal_authHead__mmVPE img {
    display: none;
  }
}

@media (min-width: 1200px) {
  div.AuthModal_authBottom__Xwhd0 {
    justify-content: flex-end;
  }
}
@media (min-width: 1200px) {
  div.AuthModal_authBottom--center__R923X {
    justify-content: center;
  }
}

@media (min-width: 1200px) {
  button.AuthModal_btnAuth__yZoR0 {
    max-width: 204px;
    width: 100%;
  }
}

@media (min-width: 1200px) {
  button.AuthModal_btnBack__5XVQf {
    max-width: 122px;
    width: 100%;
  }
}

@media (min-width: 1200px) {
  input.AuthModal_input__Y0sRl {
    font-weight: normal;
  }
}

@media (max-width: 1199px) {
  .AuthModal_authModal__1Sav- .modal-text {
    display: none;
  }
  .AuthModal_authModal__1Sav- .modal-bottom {
    margin-top: 64px;
  }
  .AuthModal_authModal__content__YEdI0 {
    background: #F6F7F8;
    padding: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/AuthModal/AuthModal.module.scss"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAFJ;AAKE;EACE,0BAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHJ;AAKI;EATF;IAUI,gBAAA;EAFJ;AACF;AAII;EACE,qBAAA;AAFN;AAME;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAJJ;AAMI;EAXF;IAYI,uBAAA;IACA,gBAAA;EAHJ;AACF;AAKI;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AAHN;AAKM;EARF;IASI,mBAAA;IACA,yBAAA;IACA,gBAAA;EAFN;AACF;AAQM;EADF;IAEI,kBAAA;IACA,mBAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,eAAA;EALN;AACF;AAQI;EACE,eAAA;AANN;AAUE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AARJ;;AAaE;EADF;IAEI,cAAA;IACA,kBAAA;EATF;AACF;AAYI;EADF;IAEI,aAAA;EATJ;AACF;;AAcE;EADF;IAEI,yBAAA;EAVF;AACF;AAaI;EADF;IAEI,uBAAA;EAVJ;AACF;;AAeE;EADF;IAEI,gBAAA;IACA,WAAA;EAXF;AACF;;AAeE;EADF;IAEI,gBAAA;IACA,WAAA;EAXF;AACF;;AAeE;EADF;IAEI,mBAAA;EAXF;AACF;;AAeA;EAGM;IACE,aAAA;EAdN;EAiBI;IACE,gBAAA;EAfN;EAoBA;IACE,mBAAA;IACA,YAAA;EAlBF;AACF","sourcesContent":["@import \"/src/styles/breakpoints.scss\";\n\n.authModal {\n  &__top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  &__resendBtn {\n    text-decoration: underline;\n    letter-spacing: -0.02em;\n    color: #457CFA;\n    margin-bottom: 4px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n\n    @media (min-width: 1200px) {\n      margin-bottom: 0;\n    }\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n\n  &__codeEnd {\n    font-size: 14px;\n    color: var(--error);\n    line-height: 12px;\n    text-align: left;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    transition: 0.15s;\n\n    @media (min-width: 1200px) {\n      justify-content: center;\n      margin-top: 12px;\n    }\n\n    span {\n      margin-right: 6px;\n      margin-bottom: 4px;\n      color: var(--error);\n      font-size: var(--fz-sm);\n      font-weight: 600;\n      line-height: var(--lh-md);\n\n      @media (min-width: 1200px) {\n        font-weight: normal;\n        line-height: var(--lh-sm);\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  :global {\n    .error-text {\n      @media (min-width: 1200px) {\n        text-align: center;\n        font-weight: normal;\n        left: 0;\n        right: 0;\n        width: auto;\n        margin-top: 4px;\n      }\n    }\n\n    .modal-title {\n      font-size: 24px;\n    }\n  }\n\n  .error-validation {\n    position: absolute;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    line-height: 16px;\n    color: #FF3C3C;\n    margin: 12px auto 0;\n  }\n}\n\ndiv.authHead {\n  @media (min-width: 1200px) {\n    display: block;\n    text-align: center;\n  }\n\n  img {\n    @media (min-width: 1200px) {\n      display: none;\n    }\n  }\n}\n\ndiv.authBottom {\n  @media (min-width: 1200px) {\n    justify-content: flex-end;\n  }\n\n  &--center {\n    @media (min-width: 1200px) {\n      justify-content: center;\n    }\n  }\n}\n\nbutton.btnAuth {\n  @media (min-width: 1200px) {\n    max-width: 204px;\n    width: 100%;\n  }\n}\n\nbutton.btnBack {\n  @media (min-width: 1200px) {\n    max-width: 122px;\n    width: 100%;\n  }\n}\n\ninput.input {\n  @media (min-width: 1200px) {\n    font-weight: normal;\n  }\n}\n\n\n@media (max-width: $desktop) {\n  .authModal {\n    :global {\n      .modal-text {\n        display: none;\n      }\n      \n      .modal-bottom {\n        margin-top: 64px;\n      }\n    }\n  }\n\n  .authModal__content {\n    background: #F6F7F8;\n    padding: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"authModal__top": `AuthModal_authModal__top__AjVIH`,
	"authModal__resendBtn": `AuthModal_authModal__resendBtn__uow7O`,
	"authModal__codeEnd": `AuthModal_authModal__codeEnd__4MYI0`,
	"authModal": `AuthModal_authModal__1Sav-`,
	"error-validation": `AuthModal_error-validation__2OuNs`,
	"authHead": `AuthModal_authHead__mmVPE`,
	"authBottom": `AuthModal_authBottom__Xwhd0`,
	"authBottom--center": `AuthModal_authBottom--center__R923X`,
	"btnAuth": `AuthModal_btnAuth__yZoR0`,
	"btnBack": `AuthModal_btnBack__5XVQf`,
	"input": `AuthModal_input__Y0sRl`,
	"authModal__content": `AuthModal_authModal__content__YEdI0`
};
export default ___CSS_LOADER_EXPORT___;
